// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader-box[data-v-f7f56cbe]{display:flex;align-items:center;justify-content:center;flex-direction:column}.loading_text[data-v-f7f56cbe]{text-align:center;color:#fff;font-size:16px;margin-top:5px;font-weight:500}", ""]);
// Exports
module.exports = exports;
